import { useSearchParams } from 'react-router-dom';
import { isDemoScenario } from '@/features/marketing-shared';
import { useEmailMarketing } from './context';

export function useEmailMarketingPaths() {
  const { scope, mockMode } = useEmailMarketing();
  const [params] = useSearchParams();
  const raw = params.get('cenario');
  // O cenário só existe no modo mock; fora dele a URL fica limpa.
  const scenario = mockMode && isDemoScenario(raw) ? raw : null;
  const root = scope.root;
  const platform = scope.kind === 'platform';

  const withScenario = (path: string) => {
    if (!scenario || scenario === 'normal') return path;
    const [pathname, query = ''] = path.split('?');
    const next = new URLSearchParams(query);
    next.set('cenario', scenario);
    const qs = next.toString();
    return qs ? `${pathname}?${qs}` : pathname;
  };

  const createPath = (templateId?: string) => {
    const query = templateId ? `?template=${encodeURIComponent(templateId)}` : '';
    return `${root}/campanhas/nova${query}`;
  };

  return {
    root,
    list: withScenario(`${root}/campanhas`),
    // Na plataforma, a biblioteca é uma aba da página; o editor tem rota própria.
    templates: withScenario(platform ? `${root}?aba=templates` : `${root}/templates`),
    templateCreate: withScenario(`${root}/templates/novo`),
    templateEdit: (id: string) => withScenario(`${root}/templates/${id}/editar`),
    settings: withScenario(`${root}/configuracao`),
    create: createPath(),
    createWithTemplate: (templateId: string) => createPath(templateId),
    detail: (id: string) => withScenario(`${root}/campanhas/${id}`),
    edit: (id: string) => withScenario(`${root}/campanhas/${id}/editar`),
  };
}
